module.exports = __webpack_public_path__ + "img/ic_price.e5255fc.svg";